<template>

  <el-dialog
    :title="Adi"
    :visible="MakbuzDetayModal"
    center
    append-to-body
    width="50%">
    <Yukleniyor :data="lo"></Yukleniyor>
    <div v-if="mNo">
      <a @click="$emit('MakbuzDetayModal', false)" class="ModalKapat"><i class="el-icon-close"></i></a>
      <Tahsilat :IptalMakbuzu="IptalMakbuzu" :data="Detay" @MakbuzDetayModal="$emit('MakbuzDetayModal', false)" v-if="Detay.Bilgi.Tur==1"></Tahsilat>
      <Devir :IptalMakbuzu="IptalMakbuzu" :data="Detay" @MakbuzDetayModal="$emit('MakbuzDetayModal', false)" v-if="Detay.Bilgi.Tur==2"></Devir>
      <Fisler :IptalMakbuzu="IptalMakbuzu" :data="Detay" @MakbuzDetayModal="$emit('MakbuzDetayModal', false)"
              v-if="Detay.Bilgi.Tur==4 || Detay.Bilgi.Tur==3"></Fisler>
      <div class="alert alert-danger text-center" v-if="Iptal">
        {{IptalDetay}}
      </div>
    </div>
  </el-dialog>

</template>

<script>
import Tahsilat from "./Makbuz/Tahsilat";
import Fisler from "./Makbuz/Fisler";
import Devir from "./Makbuz/Devir";
import Yukleniyor from "../../Doc/Yukleniyor";

export default {
  components: {Yukleniyor, Devir, Fisler, Tahsilat},
  props: ['MakbuzDetayModal', 'mNo', 'Iptal','IptalDetay'],
  data() {
    return {
      Adi: 'Makbuz Detay',
      lo: false,
      IptalMakbuzu: false,
      Detay: {
        Bilgi: {
          Tur: 0
        }
      },
    }
  },
  methods: {
    MakbuzGetir() {
      this.lo = true
      this.$store.dispatch("Get", {path: 'vezne/makbuz/' + this.mNo})
        .then(response => {
          if (response.Durum === 'OK') {
            this.Detay = response
            this.lo = false
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
            this.lo = false
          }
        });
    }
  },
  created() {
    if (this.Iptal) {
      this.IptalMakbuzu = true
      this.Detay = this.Iptal;
    } else {
      this.MakbuzGetir();
    }
  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Vezne/MakbuzDetay.vue